import { ChevronLeft } from 'lucide-react'
import React, { useState } from 'react'
import { SavePArtnerDataByObject } from '../../ActionCreator'
import moment from 'moment'
import Loader from '../../../../../presentationals/Loader/Loader.component'
export default function AddCampaign({ handleCustomTab, overallData, Data }) {
    const [loader, setLoader] = useState(false)
    const [objectData, setObjectData] = useState({
        aggregatorName: Data?.name,
        aggregatorId: Data?.id,
        partnerName: "",
        // partnerCode: "",
        // partnerType: "",
        partnerStatus: "",
        partnerOnboardingDate: moment(new Date()).format("YYYY-MM-DD"),
        defaultPricing: overallData?.crmMappingKey ?? "N/A",
        // commercialModeltype: "",      
    })

    const handleChange = (e, type) => {
        const { value } = e.target;
        setObjectData((prev) => ({
            ...prev,
            [type]: value
        }))
    }

    const handleSave = () => {
        const obj = {
            partnerName: objectData?.partnerName ?? "",
            aggregatorId: objectData?.aggregatorId ?? "",
            companyName: objectData?.aggregatorName ?? "",
            date: moment(objectData?.partnerOnboardingDate).format("DD-MM-YYYY") ?? "",
            isStatus: objectData?.partnerStatus ?? "",
        }
        setLoader(true)
        SavePArtnerDataByObject(obj, callback => {
            setLoader(false)
            handleCustomTab("", "")
        })
    }

    return (
        <>
            {loader ? <Loader /> : ""}
            <div className='OverView-Main-Section'>
                <div className='HeadingFilter-Section'>
                    <div>
                        <h4 style={{ display: 'inline-flex', gap: '5px', alignItems: 'center', cursor: 'pointer' }} onClick={() => handleCustomTab("", "")}><ChevronLeft style={{ width: 'auto' }} /> Partner Registration</h4>
                    </div>
                    <div className='topsTabs' style={{ border: 'none' }}>
                        <div className='rightTabs' style={{ padding: '0' }}>
                            <button className={`rightSideBtn `} style={{ border: '1px solid #035865', color: '#035865' }} onClick={() => handleCustomTab("", "")}>Cancel</button>
                            <button className={`rightSideBtn active`} style={{ background: '#035865', color: '#fff' }} onClick={() => handleSave()}>Save</button>
                        </div>
                    </div>
                </div>

                <div style={{ background: '#fff', borderRadius: '10px', padding: '20px', border: '1px solid #eee', marginTop: '20px' }}>
                    <div className="row">
                        <div className="col-sm-3 col-xs-12">
                            <div className='customInput-box'>
                                <label htmlFor="" className="label-new">Aggregator Name</label>
                                <input disabled style={{background:"#f2f2f2"}} className='customInput-new' type="text" value={objectData?.aggregatorName} onChange={(e) => handleChange(e, "aggregatorName")} />
                            </div>
                        </div>
                        <div className="col-sm-3 col-xs-12">
                            <div className='customInput-box'>
                                <label htmlFor="" className="label-new">Aggregator ID</label>
                                <input disabled style={{background:"#f2f2f2"}} className='customInput-new' type="text" value={objectData?.aggregatorId} onChange={(e) => handleChange(e, "aggregatorId")} />
                            </div>
                        </div>
                        <div className="col-sm-3 col-xs-12">
                            <div className='customInput-box'>
                                <label htmlFor="" className="label-new">Partner Name</label>
                                <input className='customInput-new' type="text" value={objectData?.partnerName} onChange={(e) => handleChange(e, "partnerName")} />
                            </div>
                        </div>
                        {/* <div className="col-sm-3 col-xs-12">
                            <div className='customInput-box'>
                                <label htmlFor="" className="label-new">Partner Code</label>
                                <input className='customInput-new' type="text" value={objectData?.partnerCode} onChange={(e)=>handleChange(e,"partnerCode")}/>
                            </div>
                        </div> */}
                        {/* <div className="col-sm-3 col-xs-12">
                            <div className='customInput-box'>
                                <label htmlFor="" className="label-new">Partner Type</label>
                                <select className='customInput-new' type="text" value={objectData?.partnerType} onChange={(e)=>handleChange(e,"partnerType")}>
                                    <option value={""}>Select Option</option>
                                </select>
                            </div>
                        </div> */}
                        <div className="col-sm-3 col-xs-12">
                            <div className='customInput-box'>
                                <label htmlFor="" className="label-new">Partner Status</label>
                                <select className='customInput-new' type="text" value={objectData?.partnerStatus} onChange={(e) => handleChange(e, "partnerStatus")}>
                                    <option value={""}>Select Option</option>
                                    <option value={true}>Active</option>
                                    <option value={false}>InActive</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: '20px' }}>
                        <div className="col-sm-3 col-xs-12">
                            <div className='customInput-box'>
                                <label htmlFor="" className="label-new">Partner Onboarding Date</label>
                                <input className='customInput-new' type="date" value={objectData?.partnerOnboardingDate} onChange={(e) => handleChange(e, "partnerOnboardingDate")} />
                            </div>
                        </div>
                        <div className="col-sm-3 col-xs-12">
                            <div className='customInput-box'>
                                <label htmlFor="" className="label-new">Default Pricing</label>
                                <input disabled style={{background:"#f2f2f2"}} className='customInput-new' type="text" value={objectData?.defaultPricing} onChange={(e) => handleChange(e, "defaultPricing")} />
                            </div>
                        </div>
                    </div>
                    {/* <div className="row" style={{marginTop:'20px'}}>
                        <div className="col-sm-3 col-xs-12">
                            <div className='customInput-box'>
                                <label htmlFor="" className="label-new">Commercial Model Type</label>
                                <select className='customInput-new' type="text" value={objectData?.commercialModeltype} onChange={(e)=>handleChange(e,"commercialModeltype")}>
                                    <option value={""}>Select Option</option>
                                </select>
                            </div>
                        </div>
                        
                    </div> */}

                </div>
            </div>
        </>
    )
}
